import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import { RootState } from '../../store/store';
import { queryParams } from '../../utils/query-string';
import { IListResponse } from '../../configs/constants';
import { IParams, ITags } from './tags';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 2 });

export const tagsApi = createApi({
  reducerPath: 'tagsApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: ['Tag'],
  endpoints: (builder) => ({
    getTags: builder.query<
      IListResponse<ITags>,
      { page: number; pageSize: number; keyword?: string }
    >({
      query: ({ page, pageSize, keyword }) => {
        const params: IParams = {
          take: pageSize,
          skip: (page - 1) * pageSize,
        };
        if (keyword) params.keyword = keyword;
        return {
          url: `tags?${queryParams(params)}`,
          method: 'GET',
        };
      },
      providesTags: ['Tag'],
    }),
    addTag: builder.mutation<{ data: ITags; type: string }, any>({
      query: (body) => {
        return {
          url: 'tags',
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['Tag'],
    }),
  }),
});

export const { useGetTagsQuery, useAddTagMutation } = tagsApi;
